<template>
  <div class="formDesigner">
    <fc-designer ref="designer" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: ""
    };
  },
  mounted() {},
  methods: {
    setConfig() {
      this.$refs.designer.config = {
        disabled: ["field", "title", "info", "control"]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.formDesigner {
  width: 100%;
  height: 100%;
}
</style>
